import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appConsentAnswer]',
})
export class ConsentAnswerDirective implements AfterViewInit {

  constructor(private el: ElementRef) {
  }

  public ngAfterViewInit(): void {
    this.recalculate();
    window.addEventListener('orientationchange', () => this.recalculate());
    window.addEventListener('resize', () => this.recalculate());
  }

  public recalculate(): void {
    const labels = this.el.nativeElement.querySelectorAll('.consent-yes, .consent-no');
    const heights = Array.from(labels).map((label: HTMLElement) => label.getBoundingClientRect().height);
    let maxHeight = Math.max(...heights);
    const elNoAltText = this.el.nativeElement.querySelector('.consent-alt-no');

    if (elNoAltText) {
      maxHeight = Math.max(maxHeight, elNoAltText.getBoundingClientRect().height);
      elNoAltText.style.height = `${maxHeight}px`;
    }

    labels.forEach(label => {
      label.style.height = `${maxHeight}px`;
    });

  }
}
